var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudTypeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.628,
    height: 20.443,
    viewBox: "0 0 36.628 20.443",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "onedrive_cloud",
    transform: "translate(-220.048 -274.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2162",
    "data-name": "Path 2162",
    d: "M319.033,326.806c0-.093.015-.185.015-.279,0-3.629-3.23-6.571-7.214-6.571a7.733,7.733,0,0,0-3.495.824,7.31,7.31,0,0,0-6.434-3.61c-3.985,0-7.214,2.942-7.214,6.571a5.957,5.957,0,0,0,.1,1.049,5.3,5.3,0,0,0-.853-.077,5.859,5.859,0,0,0,0,11.7h24.61a5.067,5.067,0,0,0,5.286-4.814,5.014,5.014,0,0,0-4.8-4.793Z",
    transform: "translate(-67.759 -41.811)",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 1.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudTypeIcon);
export default __webpack_public_path__ + "static/media/cloudTypeIcon.6df2abaaa9b3a4dc4377ed8c1ef89387.svg";
export { ForwardRef as ReactComponent };